import React, { useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import Tooltip from '../../../Tooltip';
import Icon from '../../../Icon';
import { useTranslation } from '../../../Translator';

const CopyIcon = ({ value }) => {
  const { t } = useTranslation('components');
  const [copied, setCopied] = useState(false);

  const icon = copied ? {
    name: 'checkmark-circle',
    color: 'green',
  } : {
    name: 'duplicate',
    color: 'gray',
  };

  const handleCopy = () => {
    if (copied) {
      return;
    }

    setCopied(true);

    setTimeout(() => {
      setCopied(false);
    }, 2000);
  };

  return (
    <Tooltip
      content={copied ? t('copied') : t('copy')}
      preventHideOnMouseDown
    >
      <div>
        <CopyToClipboard text={value}>
          <div
            role="button"
            tabIndex={0}
            onClick={handleCopy}
          >
            <Icon name={icon.name} color={icon.color} />
          </div>
        </CopyToClipboard>
      </div>
    </Tooltip>
  );
};

export default CopyIcon;
